import * as R from 'ramda'

import { Constant, Nil, PluralForms } from '../types'

export const getPluralForm = <T = string, K = Constant[]>(
  amount: number,
  formats: {
    fallback: T | K
    plural: T | K
    singular: T | K
    singularOrPlural: T | K
  },
): typeof formats.fallback extends T ? T : K =>
    R.cond<any, any>([
      [R.equals(0), R.always(formats.singularOrPlural || formats.fallback)],
      [R.equals(1), R.always(formats.singular || formats.fallback)],
      [() => R.gt(amount, 1), R.always(formats.plural || formats.fallback)],
      [R.T, R.always(formats.fallback)],
    ])(amount)

// This is a workaround to work as a fallback, that's because plurals in other languages
// are not so straightforward. And just by adding "(s)" won't be always the right plural form
export const pluralizeOneOrOther = (text: string | Nil) =>
  text && !text.endsWith('(s)') ? `${text}(s)` : text

export const getPluralUnitKey = <T extends string, K extends string>(
  name: Lowercase<K> | Uppercase<K>,
  suffix: PluralForms,
): T => `${R.toUpper(name)}_${suffix}` as T
